import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <header className="sticky top-0 z-40 w-full bg-white/95 backdrop-blur border-b border-border">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <img
              src="/logo-ifd.jpg"
              alt="Italian Fast Delivery"
              className="h-11 w-11 rounded-xl object-cover object-top shadow-sm"
            />
            <span className="flex flex-col leading-none">
              <span className="font-display font-extrabold text-[15px] tracking-tight text-foreground">
                ITALIAN<span className="text-primary">Fast</span>
              </span>
              <span className="font-display font-extrabold text-[15px] tracking-tight text-foreground -mt-0.5">
                DELIVERY
              </span>
            </span>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
